import { w as writable } from "./index2.js";
const listView = writable(false);
export {
  listView as l
};
//# sourceMappingURL=viewStore.js.map
